/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuSearchResults_itemFacetSearch$ref = any;
export type SbSharedRefineMenuTypeahead_viewer$ref = any;
export type SbSharedRefineMenuTypeahead_viewer = {
    readonly itemFacetSearch?: {
        readonly " $fragmentRefs": SbSharedRefineMenuSearchResults_itemFacetSearch$ref;
    } | null;
    readonly " $refType": SbSharedRefineMenuTypeahead_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeahead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "facetName",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "itemFacetSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "facetName",
              "variableName": "facetName"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef"
            }
          ],
          "concreteType": "ItemFacetsQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefineMenuSearchResults_itemFacetSearch",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e2f66872966de99fdaea29e77140a2f3';
export default node;
